.filtersWrapper {
  display: flex;
  gap: 8px;
}

.resetAllButtonWrapper {
  margin-left: 8px;
}
